<template>
  <div v-show="false" id="charts"></div>
</template>
<script>
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  import Highcharts from 'highcharts';
  import ImgLogoNorven from '@/assets/logo_norven';

  export default {
    name: 'RelatorioPDF',

    props: {
      dados: {
        type: Array,
        required: true
      }
    },

    emits: ['closeLoading'],

    methods: {
      gerarRelatorioPDF(tuc) {
        const dadosFiltrados = [];
        const svgs = [];

        this.dados.forEach((dado) => {
          if (dado.TUC === tuc) {
            dadosFiltrados.push(dado);
          }
        });

        dadosFiltrados.forEach((dado) => {
          let chart = Highcharts.chart('charts', {
            chart: {
              type: 'boxplot'
            },
            title: {
              text: 'Cod: ' + dado['CodMaterial']
            },
            series: [
              {
                name: dado['CodMaterial'],
                color: '#e5502c',
                data: [
                  {
                    x: parseInt(dado['CodMaterial']),
                    high: parseFloat(dado['maximo']),
                    q3: parseFloat(dado['3_quartil']),
                    median: parseFloat(dado['2_quartil']),
                    q1: parseFloat(dado['1_quartil']),
                    low: parseFloat(dado['minimo'])
                  }
                ],
                tooltip: {
                  headerFormat: '',
                  pointFormat: `
                <b>MÁXIMO: </b>{point.high}<br>
                <b>TERCEIRO QUARTIL:</b> {point.q3}<br>
                <b>MEDIANA:</b> {point.median}<br>
                <b>PRIMEIRO QUARTIL:</b> {point.q1}<br>
                <b>MÍNIMO:</b> {point.low}<br>
              `,
                  valueDecimals: 2
                }
              }
            ]
          });
          svgs.push(chart.getSVG());
        });

        let itemsA = [];
        let itemsB = [];

        for (let i in svgs) {
          if (i % 2 == 0) {
            itemsA.push({
              svg: svgs[i],
              fit: [250, 200]
            });
          } else {
            itemsB.push({
              svg: svgs[i],
              fit: [250, 200]
            });
          }
        }

        let TableRowA = [
          [
            { text: 'TUC', style: 'tableHeader' },
            { text: 'COD.M', style: 'tableHeader' },
            { text: 'MAX', style: 'tableHeader' },
            { text: 'Q3', style: 'tableHeader' },
            { text: 'Q2', style: 'tableHeader' },
            { text: 'Q1', style: 'tableHeader' },
            { text: 'MIN', style: 'tableHeader' }
          ]
        ];

        let TableRowB = [
          [
            { text: 'TUC', style: 'contentRows', alignment: 'center' },
            { text: 'COD.M', style: 'tableHeader', alignment: 'center' },
            { text: 'TOTAL', style: 'tableHeader' },
            { text: 'MEDIA', style: 'tableHeader' },
            { text: 'DP', style: 'tableHeader' },
            { text: 'PV_MAX', style: 'tableHeader' },
            { text: 'PV_MIN', style: 'tableHeader' }
          ]
        ];

        dadosFiltrados.forEach((dado) => {
          let rowA = [];

          rowA.push(dado.TUC);
          rowA.push(dado.CodMaterial);
          rowA.push(this.convertDecimalToBR(dado.maximo));
          rowA.push(this.convertDecimalToBR(dado['3_quartil']));
          rowA.push(this.convertDecimalToBR(dado['2_quartil']));
          rowA.push(this.convertDecimalToBR(dado['1_quartil']));
          rowA.push(this.convertDecimalToBR(dado.maximo));
          TableRowA.push(rowA);

          let rowB = [];
          rowB.push(dado.TUC);
          rowB.push(dado.CodMaterial);
          rowB.push(this.convertDecimalToBR(dado['somatorio']));
          rowB.push(this.convertDecimalToBR(dado['media']));
          rowB.push(this.convertDecimalToBR(dado['desvio_padrao']));
          rowB.push(this.convertDecimalToBR(dado['pv_max']));
          rowB.push(this.convertDecimalToBR(dado['pv_min']));
          TableRowB.push(rowB);
        });

        const docDefinition = {
          pageSize: 'A4',
          pageMargins: [40, 60, 40, 60],
          header: {
            columns: [
              {
                image: ImgLogoNorven.data,
                width: 150,
                height: 70,
                margin: [20, -10]
              },
              {
                text: 'Relatório PDF - Variações de Preço Unitário',
                margin: [130, 20]
              }
            ]
          },
          content: [
            {
              text: 'Boxplot TUC ' + tuc,
              style: 'headerTableStyle'
            },
            {
              columns: [itemsA, itemsB]
            },
            {
              text: '\n\nEspecificação dos códigos da TUC ' + tuc + ' dados Boxplot',
              style: 'headerTableStyle'
            },
            {
              style: 'tableContent',
              table: {
                widths: [30, 50, 60, 65, 65, 65, 60],
                headerRows: 1,
                body: TableRowA
              },
              layout: 'headerLineOnly'
            },
            {
              text: '\nEspecificação dos códigos da TUC ' + tuc + ' dados add',
              style: 'headerTableStyle'
            },
            {
              style: 'tableContent',
              table: {
                widths: [30, 50, 60, 65, 65, 65, 60],
                headerRows: 1,
                body: TableRowB
              },
              layout: 'headerLineOnly'
            }
          ],
          styles: {
            headerTableStyle: {
              fontSize: 14,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            contentRows: {
              fontSize: 12
            },
            tableContent: {
              margin: [10, 0, 0, 0]
            },
            logoNorven: {
              fontSize: 26,
              bold: true
            }
          },
          footer: {
            columns: [
              {
                text: 'Norven\n Av. Jamel Cecílio, 2690 - Ed. Tokyo, Sala 1406\n Jardim Goiás, Goiânia - GO',
                margin: [50, 20],
                style: {
                  fontSize: 8
                }
              },
              {
                text: 'Telefones: +55 62 3602-1236\n Email: contato@norven.com.br\n Site: norven.com.br',
                margin: [30, 20],
                style: {
                  fontSize: 8
                }
              }
            ]
          }
        };
        this.$emit('closeLoading');

        pdfMake.createPdf(docDefinition).open();
      },
      convertDecimalToBR(num, minimumFractionDigits = 2, maximumFractionDigits = 2) {
        return Number(num).toLocaleString('pt-BR', {
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits
        });
      }
    }
  };
</script>
